import React, { useState } from "react";
import shortid from "shortid";
import { Box, Button, Checkbox, Column, Columns, Control, Field, Input, Table } from "@allxsmith/bestax-bulma";
import Part from "./Part";
import {ToastContainer, toast} from "react-toastify";
import { Link } from "react-router-dom";
import {getPartCustomerCost, getWorkItemCustomerCost, getWorkItemEstimateCustomerCost} from "../../utils";
import ModifyQuoteModal from "./ModifyQuoteModal";
import WorkTypePicker from "../Job/WorkTypePicker";

function WorkSection(props) {
  const [modifyQuoteModalOpen, setModifyQuoteModalOpen] = useState(false);

  const handleChange = e => {
    const newWorkItem = getNewWorkItem(e);
    props.update_work(newWorkItem);
  };

  const getNewWorkItem = e => {
    let chargeable =
      e.target.name === "chargeable"
        ? e.target.value
        : props.workItem.chargeable;
    let customer = chargeable ? props.hireCustomer : props.customer;

    let newWorkItem = { ...props.workItem, [e.target.name]: e.target.value };
    if (
      e.target.name === "estimated_labour_hours" ||
      e.target.name === "chargeable"
    ) {
      newWorkItem = getWorkItemEstimateCustomerCost(props.vehicle, props.supplier, newWorkItem, customer, props.appDefaults.default_labour_estimate_rate);
    }
    if (props.quote.duplicate && (e.target.name === "labour_hours" || e.target.name === "chargeable")){
      // as the quote does not have a workshop props.supplier will always be undefined
      newWorkItem = getWorkItemCustomerCost(props.vehicle, props.supplier, newWorkItem, customer, false);
    }
    return newWorkItem;
  };

  const readyForInvoicing = () => {
    // if(
    //     ((!props.workItem.work_type)
    //     ||
    //     (!props.workItem.job))
    //     &&
    //     (
    //         !(props.workItem.work_type && props.workItem.work_type.free_of_charge && !props.workItem.work_type.approval_needed)
    //         ||
    //         !(props.workItem.work_type && props.workItem.work_type.free_of_charge && props.workItem.work_type.approval_needed && props.workItem.approval_received)
    //         ||
    //         !(props.workItem.job_workshop_invoice_number)
    //     )
    // ) {
    if(!props.workItem.work_type || !props.workItem.job || !props.workItem.job_approved){
      return false;
    }
    if(props.workItem.work_type && props.workItem.work_type.free_of_charge && props.workItem.work_type.approval_needed && !props.workItem.approval_received){
      return false;
    }
    if(!props.workItem.work_type.free_of_charge && !props.workItem.job_workshop_invoice_number){
      return false;
    }

    // if(props.workItem.work_type && props.workItem.work_type.free_of_charge && !props.workItem.work_type.approval_needed){
    //   console.log("yes");
    // }
    for (let i = 0; i < props.workItem.parts.length; i++) {
      if (
        !props.workItem.parts[i].part_invoice_number &&
        !props.workItem.parts[i].from_stock &&
        !props.workItem.parts[i].backorder &&
        !props.workItem.parts[i].backorder_expected_date
      ) {
        return false;
      }
    }
    return true;
  };

  const onToggleOriginalQuote= () => {
    let newWorkItem = {
      ...props.workItem,
      added_after_quote: !props.workItem.added_after_quote
    };
    props.update_work(newWorkItem);
  };

  const handleCheck = (e) => {
    const toUpdate = {
      target: {
        name:e.target.name,
        value: e.target.checked
      }
    };
    handleChange(toUpdate);
  }

  const onCheck = () => {
    const newWorkItem = getNewWorkItem({
      target: {
        name: "chargeable",
        value: !props.workItem.chargeable
      }
    });
    newWorkItem.parts = props.workItem.parts.map(part => {
      return {
        ...part,
        customer_cost: getPartCustomerCost(
          part,
          newWorkItem.chargeable ? props.hireCustomer : props.customer,
          props.appDefaults
        )
      };
    });
    props.update_work(newWorkItem);
  };

  const addPart = e => {
    props.update_work(
      {
        ...props.workItem,
        parts: props.workItem.parts.concat({
          key: shortid.generate(),
          name: "",
          cost: 0,
          estimated_cost: 0,
          supplier: {},
          date_ordered: "",
          part_invoice_number: "",
          part_number: "",
          from_stock: false,
          backorder_expected_date: "",
          to_be_ordered: false,
          cost_override: false,
          customer_cost: 0,
          estimated_customer_cost: 0
        })
      }
    );
  };

  const updateParts = (part, index) => {
    let newParts = [...props.workItem.parts];
    newParts.splice(index, 1, part);
    const newWorkItem = {
      ...props.workItem,
      parts: newParts
    };
    props.update_work(newWorkItem);
  };

  const removePart = (index, part) => {
    if (!part.part) {
      let newParts = [...props.workItem.parts];
      newParts.splice(index, 1);
      const newWorkItem = {
        ...props.workItem,
        parts: newParts
      };
      props.update_work(newWorkItem);
    } else {
      toast.error("This Part is linked to a Job Card. You must delete the Part on the Job Card first!", {position: "top-right"});
    }
  };

  let allMatches = props.workItem.estimate_matches_job;

  let className = props.workItem.work ? "box-border-amber" : "";
  className = readyForInvoicing() ? "box-border-green" : className;
  className = props.workItem.work && !allMatches ? "box-border-red" : className;


  const handleTypeSelect = e => {
    let value = e.target.value === "BLANK" ? null : props.workTypeObjects[e.target.value];
    const toUpdate = {
      target: {
        name: "work_type",
        value: value
      }
    };
    handleChange(toUpdate);
  }

  const formatJobStatus = (data) => {
    // Takes a string
    let splitData = data.split("_");
    let returnString = "";
    splitData.forEach((word) => {
      returnString = returnString+" "+word
    });
    return returnString;
  }

  return (
    <Box className={className}>
      <Columns isMultiline>
        <Column>
          {props.workItem.job ? (
            <Link to={`/editjob/${props.workItem.job}`}>
              <Button>Job Card - {props.workItem.job} - {props.workItem.workshop}</Button>
            </Link>
          ) : (
            <p>No Job Card has been created for this item!</p>
          )}
        </Column>
        <Column>
          {readyForInvoicing() ? (
            <p>This item is ready for invoicing</p>
          ) : (
            <p>This item is not ready for invoicing</p>
          )}
        </Column>
        <Column>
          {allMatches ? (
            <p>The job card associated with this item matches the estimate</p>
          ) : props.workItem.work ? (
            <p>
              The job card associated with this item does not match the
              estimate!
            </p>
          ) : (
            ""
          )}
        </Column>
        <Column>
          <p>{props.workItem.job ? formatJobStatus(props.workItem.job_status) : ""}</p>
        </Column>
        <Column>
          <label className="label">Not Needed</label>
          <Checkbox
            name={"not_being_done"}
            checked={props.workItem.not_being_done}
            onChange={handleCheck}
            disabled={props.workItem.job}
          />
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <Control>
              <label className="label">Description</label>
              <Input
                data-testid="description"
                type="text"
                name="description"
                onChange={handleChange}
                value={props.workItem.description}
                required
                disabled={props.workItem.not_being_done || props.disabled}
              />
            </Control>
          </Field>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <Control>
              <label className="label">Charge Customer 2</label>
              <Checkbox
                type="checkbox"
                name="chargeable"
                onChange={onCheck}
                checked={props.workItem.chargeable}
                disabled={!props.hireCustomer || props.workItem.not_being_done || props.disabled}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Est. Labour Hours</label>
              <Input
                data-testid="estimated_labour_hours"
                className="input"
                type="number"
                name="estimated_labour_hours"
                onChange={handleChange}
                value={String(props.workItem.estimated_labour_hours)}
                disabled={props.workItem.not_being_done || props.disabled || props.quote.duplicate}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Est. Labour Cost</label>
            <Control>
              <Input
                className="input"
                type="number"
                name="estimated_labour_cost"
                onChange={handleChange}
                value={String(props.workItem.estimated_labour_cost)}
                disabled={props.workItem.not_being_done || props.disabled || props.quote.duplicate}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Est. Labour Charge</label>
            <Control>
              <Input
                className="input"
                type="number"
                name="estimated_customer_labour_cost"
                onChange={handleChange}
                value={String(props.workItem.estimated_customer_labour_cost)}
                disabled={props.workItem.not_being_done || props.disabled || props.quote.duplicate}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Actual Labour Hours</label>
              <Input
                data-testid="labour_hours"
                className="input"
                type="number"
                name="labour_hours"
                value={String(props.workItem.labour_hours)}
                disabled={!props.quote.duplicate}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Actual Labour Cost</label>
            <Control>
              <Input
                className="input"
                type="number"
                name="labour_cost"
                onChange={handleChange}
                value={String(props.workItem.labour_cost)}
                disabled={true}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Actual Labour Charge</label>
            <Control>
              <Input
                className="input"
                type="number"
                name="customer_labour_cost"
                value={String(props.workItem.customer_labour_cost)}
                onChange={handleChange}
                disabled={!props.quote.duplicate}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Workshop Invoice No</label>
            <Control>
              <Input
                className="input"
                type="text"
                name="job_workshop_invoice_number"
                value={props.workItem.job_workshop_invoice_number}
                disabled
              />
            </Control>
          </Field>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
            <WorkTypePicker
              options={props.workTypes}
              work={props.workItem}
              onSelect={handleTypeSelect}
              inlineEdit={false}
              disabled={props.workItem.not_being_done}
            />
        </Column>
        <Column>
          <label className="label">Work Complete</label>
          <Checkbox
            name={"complete"}
            checked={props.workItem.complete}
            onChange={handleCheck}
            disabled={!(!!props.workItem.job)}
          />
        </Column>
        <Column></Column>
        <Column></Column>
        <Column></Column>
        <Column></Column>
        <Column></Column>
        <Column></Column>
      </Columns>
      <Table isFullwidth>
        <thead>
          <tr>
            <td>Name</td>
            <td>Estimated Cost</td>
            <td>Estimated Charge</td>
            <td>Supplier</td>
            <td>Part Number</td>
            <td>Invoice No</td>
            <td>Actual Cost</td>
            <td>Actual Charge</td>
            <td>Postage</td>
            <td>Stock Accrual</td>
            <td>Backorder Date</td>
            <td>To Be Ordered</td>
            <td>Remove</td>
          </tr>
        </thead>
        <tbody data-testid="parts">
          {props.workItem.parts.map((part, index) => (
            <Part
              disabled={props.disabled}
              key={part.id || part.key}
              index={index}
              part={part}
              job={props.job}
              work={props.workItem}
              updateParts={updateParts}
              removePart={removePart}
              appDefaults={props.appDefaults}
              customer={
                props.workItem.chargeable ? props.hireCustomer : props.customer
              }
              onSearchPartClick={(part, partIndex) =>
                props.onSearchPartClick(
                  part,
                  partIndex,
                  props.index,
                  props.customer
                )
              }
            />
          ))}
        </tbody>
      </Table>
      <Button
          color="primary"
          onClick={addPart}
          data-testid="add-part"
          disabled={props.workItem.not_being_done || props.disabled}
      >
        Add Part
      </Button>
      <Columns className="is-pulled-right" isMultiline>
        <Column>
          <Button
            color="warning"
            data-testid="add-to-quote"
            className="is-pulled-right"
            onClick={() => setModifyQuoteModalOpen(true)}
          >
            {props.additional ? "Add to Quote" : "Remove From Quote"}
          </Button>
        </Column>
        <Column>
          <Button
            color="danger"
            data-testid="remove-work"
            className="is-pulled-right remove-work"
            onClick={() => props.remove_work_item(props.index, props.workItem)}
            disabled={props.disabled}
          >
            Remove Work
          </Button>
        </Column>
      </Columns>
      <ModifyQuoteModal
        open={modifyQuoteModalOpen}
        setOpen={setModifyQuoteModalOpen}
        onAction={onToggleOriginalQuote}
      />
    </Box>
  );
}

export default WorkSection;
